import { Afs, AfsPageOptions } from '@schibsted-nmp/advertising-shared';

export function triggerAllAfsPlacements(afs: Afs) {
  if (!afs.query) {
    // No query, no need to trigger AFS
    return;
  }
  afs.placements.forEach((placement) => {
    triggerAfsPlacement({
      adPage: afs.adPage,
      pubId: afs.pubId,
      query: afs.query,
      container: placement.container,
      styleId: placement.styleId,
      number: 1
    });
  });
}

function triggerAfsPlacement({ container, ...afsPageOptions }: AfsPageOptions) {
  if (afsPageOptions.query) {
    try {
      window._googCsa('ads', afsPageOptions, { container });
    } catch (error) {
      console.error('Error in google ad sense [for search]: ', error);
    }
  }
}
